import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { LiveStatus } from '../../types'
import { LiveActiveHeader } from '../liveActiveHeader'
import { LiveDate } from '../liveDate'
import { LiveHeaderProps } from './liveHeader.types'

const LiveHeader = ({ isHighlight, liveDetail, className }: LiveHeaderProps) => {
  const { t } = useTranslation()

  if (isHighlight) {
    return (
      <LiveActiveHeader className={clsx('_mb-3', className)} watchCount={liveDetail?.watchCount} />
    )
  }

  if (liveDetail?.status === LiveStatus.COMPLETED) {
    return (
      <div className={clsx('_text-gray-500 _d-flex _align-items-center', className)}>
        <span className="_d-flex _font-weight-bold _mb-1 _mt-4 _text-1 _text-uppercase">
          {t('live.highlight.header_completed')}
        </span>
        <span className="_d-flex _font-weight-bold _mx-1 _mb-1 _mt-4 _text-1">-</span>
        <LiveDate startAt={liveDetail?.endAt} />
      </div>
    )
  }

  return (
    <div className={clsx('_text-red', className)}>
      <LiveDate startAt={liveDetail?.startAt} />
    </div>
  )
}

export default LiveHeader
